import type { CityConfig } from "../city-template/types";

export const wahpetonConfig: CityConfig = {
  city: "Wahpeton",
  state: "North Dakota",
  stateAbbr: "ND",
  slug: "wahpeton",
  route: "/cities/wahpeton",
  title: "Emergency Passport Wahpeton, ND — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Wahpeton, ND — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Wahpeton, NDSCS students, Twin Towns area, and Richland County. No Minneapolis trip needed.",
  h1: "Emergency & Expedited Passport Services in Wahpeton, ND",
  heroSubtitle: "NDSCS student planning a study abroad semester? Twin Towns family heading to a Canadian lake for the weekend? Red River Valley professional with an overseas work assignment? We help Wahpeton residents — from NDSCS Wildcats heading abroad to families in the Twin Towns communities — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Sweeping%20panoramic%20view%20of%20Wahpeton%20North%20Dakota%20skyline%20along%20the%20Bois%20de%20Sioux%20River%20with%20Chahinkapa%20Park%20and%20the%20historic%20zoo%20area%20visible%2C%20the%20twin%20towns%20region%20with%20Breckenridge%20Minnesota%20across%20the%20river%2C%20NDSCS%20campus%20buildings%2C%20Red%20River%20Valley%20agricultural%20landscape%20stretching%20to%20the%20horizon%2C%20dramatic%20North%20Dakota%20big%20sky%20at%20golden%20sunset%20hour%20with%20warm%20amber%20light%2C%20editorial%20travel%20photography&width=1800&height=700&seq=wahpeton-hero-2026&orientation=landscape",
  heroImageAlt: "Wahpeton North Dakota skyline along the Bois de Sioux River at golden hour",
  geoPosition: "46.2652;-96.6059",
  geoPlacename: "Wahpeton, North Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Nearest regional passport agency — located approximately 260 miles from Wahpeton; about a 4-hour drive",
  },
  nearbyCitiesZips: [
    { name: "Wahpeton", zips: "58075, 58076" },
    { name: "Breckenridge", zips: "56520" },
    { name: "Hankinson", zips: "58041" },
    { name: "Wyndmere", zips: "58081" },
    { name: "Lidgerwood", zips: "58053" },
    { name: "Fairmount", zips: "58030" },
    { name: "Milnor", zips: "58060" },
  ],
  benefits: [
    { icon: "ri-graduation-cap-line", title: "NDSCS Study Abroad & International Students", desc: "North Dakota State College of Science brings students from across the globe to Wahpeton. International students need passport services for travel home, while NDSCS students heading abroad for study programs require fast, reliable passport processing." },
    { icon: "ri-community-line", title: "Twin Towns — Cross-Border Living", desc: "Wahpeton and Breckenridge, MN sit directly across from each other on the Bois de Sioux River. Residents live, work, and shop in both states — creating unique documentation needs that require understanding of the North Dakota-Minnesota border dynamic." },
    { icon: "ri-leaf-line", title: "Red River Valley Agriculture & Agribusiness", desc: "Wahpeton sits at the southern end of the Red River Valley — some of the richest farmland in the world. Ag professionals travel internationally for equipment expos, trade shows, and agricultural technology conferences — often on short notice." },
    { icon: "ri-compass-3-line", title: "Canadian Proximity & Cross-Border Travel", desc: "Wahpeton is just a few hours from Manitoba and Ontario. Weekend trips to Winnipeg, fishing expeditions in Canadian lakes, and cross-border shopping in Emerson and Pembina are part of everyday life in the Twin Towns area." },
  ],
  internalLinks: [
    { name: "Expedited passport in Fargo, ND", route: "/cities/fargo" },
    { name: "Fast passport services in West Fargo, ND", route: "/cities/west-fargo" },
    { name: "Quick passport services in Grand Forks, ND", route: "/cities/grand-forks" },
    { name: "Urgent passport services in Bismarck, ND", route: "/cities/bismarck" },
    { name: "North Dakota passport services overview", route: "/states/north-dakota" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Wahpeton via secure registered courier with direct access to the Minneapolis Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 4+ hours to Minneapolis. Wahpeton residents can ship from any UPS Store, FedEx Office, or post office in the Twin Towns area.",
  fpcOfficeDistance: "Serving Wahpeton, Breckenridge, Hankinson, Wyndmere, Lidgerwood, Fairmount, Milnor, and all Richland County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Wahpeton and the southern Red River Valley. From the NDSCS campus to the Twin Towns neighborhoods, from Richland County farm families to international students — we serve all of Wahpeton. Our courier service eliminates the need to drive 260 miles to Minneapolis for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Wahpeton and the Twin Towns region including Breckenridge, MN, Hankinson, and all Richland County communities. Our service reaches the southern Red River Valley with the same fast processing that Wahpeton residents rely on.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Wahpeton as simple as possible — with the reliability Twin Towns residents deserve. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Wahpeton travelers start online and ship documents from the UPS Store in Breckenridge or the Wahpeton Post Office — no office visit required.",
  mistakesIntro: "Wahpeton's unique position on the ND-MN border creates special passport situations — NDSCS students with study abroad deadlines, Twin Towns residents navigating two-state documentation, and agricultural professionals with international travel needs. Here are the most common mistakes we see.",
  testimonialsIntro: "Wahpeton travelers — from NDSCS Wildcats to Twin Towns families to Red River Valley ag professionals — trust us when international travel deadlines arrive and Minneapolis is simply too far.",
  faqIntro: "Have questions about expedited passports in Wahpeton, ND? Here are the most common ones we hear from the Twin Towns and Richland County communities.",
  statePageRoute: "/states/north-dakota",
  statePageName: "North Dakota",
  servicesIntro: "Whether you're an NDSCS student preparing for a study abroad adventure, a Twin Towns family planning a Canadian getaway, or an agricultural professional heading to an international trade show — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30-100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.nd.gov/divisions/driverslicense/driverslicense.htm",
  dmvLabel: "North Dakota Department of Transportation — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Minneapolis agency is 260 miles from Wahpeton", "4-hour drive — takes most of a day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Minneapolis trip needed", "Ideal for NDSCS students and Twin Towns families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Wahpeton or Breckenridge", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "NDSCS study abroad deadline in 3 days? Family emergency overseas requiring immediate travel? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Wahpeton travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Wahpeton residents renew fast — no agency visit required for most renewals. Perfect for NDSCS faculty, Twin Towns families, and ag professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Richland County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your international plans aren't derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Wahpeton family vacation stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations and IDs.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for NDSCS faculty traveling while primary passport is in visa processing, and ag professionals with overlapping international commitments.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Water damage from the Bois de Sioux River, or a passport that went through the wash during NDSCS laundry day — we help Wahpeton residents replace damaged passports quickly.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, and the Caribbean. Ideal for Wahpeton residents heading to Manitoba and Ontario for fishing and recreation.",
      bullets: ["Wallet-size convenience", "Land crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Wahpeton ND", description: "Urgent passport processing for Wahpeton North Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Wahpeton ND", description: "Fast passport renewal for Wahpeton North Dakota residents." },
    { name: "First-Time Passport Wahpeton ND", description: "New passport application services for Wahpeton North Dakota first-time applicants." },
    { name: "Child Passport Wahpeton ND", description: "Minor passport services for Wahpeton North Dakota families with children under 16." },
    { name: "Name Change Passport Wahpeton ND", description: "Passport name correction for Wahpeton residents after marriage or legal name changes." },
    { name: "Second Passport Wahpeton ND", description: "Second passport services for Wahpeton frequent travelers including NDSCS faculty." },
  ],
  testimonials: [
    {
      name: "Maria G.",
      location: "Wahpeton",
      rating: 5,
      text: "I'm an international student at NDSCS from Brazil, and my passport was expiring during fall semester. I needed it renewed fast so I could go home for Christmas break — and the Brazilian consulate in Chicago takes forever. Fast Passport Center got it done in 4 days. I made it home for the holidays.",
      service: "Expedited Passport Renewal — International Student",
    },
    {
      name: "The Johnson Family",
      location: "Wahpeton",
      rating: 5,
      text: "We've lived in Wahpeton for 15 years and finally saved up for a European river cruise. Two weeks before departure, my husband couldn't find his passport — completely MIA. Fast Passport Center expedited a replacement. We sailed the Danube through Budapest and Vienna. Trip of a lifetime.",
      service: "Lost Passport Replacement — European River Cruise",
    },
    {
      name: "Dave K.",
      location: "Breckenridge",
      rating: 5,
      text: "I'm an ag equipment dealer on the Twin Towns side. Got invited to an ag tech conference in Germany with 10 days' notice. Passport had expired. Fast Passport Center renewed it and I made the conference. Saw the latest combines and closed two deals for Red River Valley farmers.",
      service: "Expedited Passport Renewal — Ag Business Travel",
    },
    {
      name: "Kayla T.",
      location: "Wahpeton",
      rating: 5,
      text: "NDSCS study abroad program to New Zealand — I got accepted but realized my passport was expired with only 3 weeks to departure. Everyone said I'd miss the semester. Fast Passport Center expedited in 6 days. I'm writing this from my dorm in Wellington. Life-changing experience.",
      service: "Expedited Passport — Study Abroad",
    },
  ],
  facilities: [
    {
      id: "wahpeton-1",
      name: "Wahpeton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "415 2nd Ave N",
      city: "Wahpeton",
      state: "ND",
      zip: "58075",
      phone: "(701) 642-4361",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Downtown Wahpeton",
      website: "https://tools.usps.com/find-location.htm?location=1388222",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Wahpeton and Richland County. Passport photos available on-site. Appointment recommended — limited slots during NDSCS academic year.",
      icon: "ri-mail-line",
    },
    {
      id: "wahpeton-2",
      name: "Breckenridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 5th St N",
      city: "Breckenridge",
      state: "MN",
      zip: "56520",
      phone: "(218) 643-6211",
      hours: "Mon-Fri 8:30 AM - 4:00 PM (appointment required)",
      distance: "Downtown Breckenridge — across the river, about 2 miles from Wahpeton",
      website: "https://tools.usps.com/find-location.htm?location=1372813",
      websiteLabel: "USPS Location",
      notes: "Minnesota-side option for Twin Towns residents. Full passport acceptance and photo services. Convenient for Wahpeton residents who work or shop in Breckenridge.",
      icon: "ri-mail-line",
    },
    {
      id: "wahpeton-3",
      name: "Richland County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "418 2nd Ave N",
      city: "Wahpeton",
      state: "ND",
      zip: "58075",
      phone: "(701) 642-7725",
      hours: "Mon-Fri 8:00 AM - 4:30 PM",
      distance: "Downtown Wahpeton — Richland County Courthouse",
      website: "https://www.richlandcountynd.gov/",
      websiteLabel: "Richland County Website",
      notes: "Alternative to post office acceptance. Appointment recommended. Does not offer photo services — bring your own passport photo or get one at the Wahpeton Post Office first.",
      icon: "ri-government-line",
    },
    {
      id: "wahpeton-4",
      name: "Fargo Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "657 2nd Ave N",
      city: "Fargo",
      state: "ND",
      zip: "58102",
      phone: "(701) 241-6192",
      hours: "Mon-Fri 8:30 AM - 5:30 PM (appointment required)",
      distance: "Fargo — about 55 miles north of Wahpeton",
      website: "https://tools.usps.com/find-location.htm?location=1372751",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the region. More appointment availability than Wahpeton. Full passport photo and overnight shipping services. About 1 hour drive from Wahpeton.",
      icon: "ri-mail-line",
    },
    {
      id: "wahpeton-5",
      name: "Hankinson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "317 Main Ave",
      city: "Hankinson",
      state: "ND",
      zip: "58041",
      phone: "(701) 242-7711",
      hours: "Mon-Fri 9:00 AM - 3:00 PM (appointment required)",
      distance: "Hankinson — about 25 miles south of Wahpeton",
      website: "https://tools.usps.com/find-location.htm?location=1377710",
      websiteLabel: "USPS Location",
      notes: "Serves southern Richland County residents. Small facility; call ahead for passport acceptance hours and photo availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Minneapolis Passport Agency, 260 miles and 4-hour drive from Wahpeton", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Minneapolis; takes most of a day from Wahpeton", fpc: "Most Wahpeton travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — impractical from Wahpeton", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Wahpeton", agency: "260-mile drive — full day trip; impractical for most residents", fpc: "Entirely remote — forms online, ship from Wahpeton or Breckenridge, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel to Minneapolis, time off work", fpc: "Best price guarantee — 30-100% less than FedEx, Staples and resellers" },
    { feature: "Wahpeton Context", agency: "No local guidance — no NDSCS, Twin Towns, or agricultural trade expertise", fpc: "Full Wahpeton knowledge — NDSCS students, Twin Towns living, ag professionals, Canadian travel" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "NDSCS Study Abroad Last-Minute Passport Rush",
      description: "NDSCS students accepted to study abroad programs often discover expired passports just weeks before departure. Semester abroad applications and visa processing consume months — leaving passport renewal as the final, panicked step. We recommend NDSCS students check passport validity before applying to study abroad programs.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Twin Towns Cross-Border Documentation Confusion",
      description: "Wahpeton-Breckenridge residents live in two states simultaneously. Birth certificates from Minnesota hospitals, marriage licenses from North Dakota — the paperwork mix-up causes delays. We help Twin Towns residents determine which vital records office to use based on where life events actually occurred.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Canadian Fishing Trip Passport Assumptions",
      description: "Weekend fishing trips to Manitoba and Ontario are common from Wahpeton. Many residents assume their driver's license is enough for Canada — it's not. Enhanced driver's licenses work for land crossings but regular ND licenses don't. A passport book or passport card is required for all Canada entry.",
    },
    {
      icon: "ri-error-warning-line",
      title: "FAR Airport Check-In Passport Surprises",
      description: "Wahpeton is about 55 minutes from Hector International Airport in Fargo. Airlines verify passport validity at FAR check-in — not at the Minneapolis or Denver connection. Many Wahpeton travelers discover passport issues at the Fargo counter with their flight departing in hours.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Ag Professional International Travel Timing",
      description: "Red River Valley agricultural professionals travel to equipment expos in Germany, ag tech conferences in Brazil, and commodity meetings in Asia. These trips often materialize with 1-3 weeks' notice after harvest or planting seasons. Proactive passport maintenance is critical for ag professionals.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a study abroad semester, family cruise, or ag trade show." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you're an NDSCS student, Twin Towns family, or Richland County farmer." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most Wahpeton clients ship from the Wahpeton Post Office or the UPS Store across the river in Breckenridge — no Minneapolis trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so Wahpeton travelers never need to drive 260 miles to Minneapolis." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your Wahpeton address — whether that's near the NDSCS campus, in a Twin Towns neighborhood, or out in rural Richland County. No agency visit. No Minneapolis. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Wahpeton, North Dakota?", a: "We offer Wahpeton area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because the nearest regional passport agency is in Minneapolis (260 miles away), our remote courier service is the most practical fast option for the southern Red River Valley." },
    { q: "Do I need to visit a Wahpeton office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Wahpeton Post Office, Breckenridge Post Office, or Richland County Clerk), then ship documents overnight. We handle State Department submission and return your passport to your Twin Towns address." },
    { q: "Can NDSCS students get passports for study abroad?", a: "Yes. NDSCS international students and study abroad participants are among our most common Wahpeton clients. We process expedited passports for students heading to programs worldwide — from New Zealand to Germany to Japan. We understand the academic calendar and can meet tight semester deadlines." },
    { q: "What if I live in Wahpeton but my vital records are from Minnesota?", a: "Many Twin Towns residents were born in Breckenridge, MN hospitals or married in Minnesota. We help you determine which state's vital records office to contact based on where each life event occurred. Birth certificates come from the state of birth, not your current residence." },
    { q: "What is the best price for expedited passport service in Wahpeton?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30-100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Wahpeton applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos." },
    { q: "Can I get a passport photo in Wahpeton?", a: "Yes. The Wahpeton Post Office offers on-site passport photos. Breckenridge Post Office across the river also provides photo services. Walgreens in Fargo (55 minutes north) is another option. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "Can you help with passports for Canadian weekend trips from Wahpeton?", a: "Yes. The Manitoba and Ontario borders are just a few hours from Wahpeton. Canadian fishing trips, Winnipeg shopping weekends, and family visits are common. We process both passport books and passport cards. Passport cards work for land crossings — passport books are needed for any air travel within Canada." },
    { q: "How does FAR airport (Fargo) affect passport timing for Wahpeton residents?", a: "Hector International Airport is about 55 minutes from Wahpeton. Airlines verify passport documents at FAR check-in — not at your MSP or DEN connection. If your passport is expired, you won't board at Fargo. Always verify before driving to FAR." },
    { q: "I live in Wahpeton but work in Breckenridge, MN — which state's services should I use?", a: "Your physical residence determines your state — if you live in Wahpeton, you're in North Dakota. Use Richland County (ND) vital records for events that occurred in North Dakota. For acceptance facilities, you can use either Wahpeton or Breckenridge offices — whichever is more convenient. We'll guide you through any state-specific requirements." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Wahpeton Residents",
    intro: "Wahpeton's position at the southern tip of the Red River Valley — on the North Dakota-Minnesota border — creates unique travel patterns. Here's what Wahpeton residents need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "FAR — Hector International Airport (Fargo)",
        subtitle: "The region's air gateway, 55 minutes north of Wahpeton",
        description: "FAR connects the Red River Valley to the world with daily flights to Minneapolis, Denver, Chicago, Dallas, and Phoenix. Most Wahpeton international travelers drive 55 minutes to Fargo and connect through MSP or DEN for overseas flights. FAR is the closest commercial airport to Wahpeton with full international connections.",
        tip: "FAR check-in agents verify passport documents before you board. If your passport has issues, you'll find out at the Fargo counter — not at your connection. Check your passport at home in Wahpeton before making the drive.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "NDSCS Study Abroad & International Travel",
        subtitle: "Academic travelers with tight timelines",
        description: "NDSCS brings together students from across the U.S. and around the world. Study abroad programs, international student travel home during breaks, and faculty research trips create diverse passport needs. The academic calendar — with fixed semester start and end dates — means deadlines are non-negotiable.",
        tip: "NDSCS students should check passport validity at least 6 months before planned international travel. Many countries require passport validity extending 6 months beyond your planned return date. A spring break passport emergency is much harder to solve than a pre-semester renewal.",
      },
      {
        icon: "ri-car-line",
        title: "Twin Towns Cross-Border Living",
        subtitle: "The unique Wahpeton-Breckenridge connection",
        description: "Wahpeton and Breckenridge, MN are twin cities connected by bridges over the Bois de Sioux River. Residents live in one state, work in the other, shop in both, and have family scattered across the border. This two-state lifestyle creates unique documentation situations — birth certificates, marriage licenses, and vital records can come from either state.",
        tip: "Your vital records follow where events happened, not where you currently live. Born in Breckenridge, MN? You need a Minnesota birth certificate. Married in Wahpeton? Richland County, ND marriage license. We help sort out the cross-border paperwork.",
      },
      {
        icon: "ri-plant-line",
        title: "Red River Valley Agricultural Professionals",
        subtitle: "International ag trade on short notice",
        description: "Wahpeton sits in the heart of the Red River Valley — some of the most productive farmland in the world. Agricultural equipment dealers, seed company representatives, commodity traders, and farm cooperative leaders travel internationally for trade shows, technology demonstrations, and global market meetings. These trips often materialize after planting or harvest with minimal lead time.",
        tip: "Ag professionals who may travel internationally should maintain valid passports year-round. The busy seasons (spring planting and fall harvest) leave the narrowest windows for passport processing. A current passport eliminates the stress of a last-minute rush.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Wahpeton & the Bois de Sioux River",
      description: "The Bois de Sioux River defines Wahpeton's geography and identity — forming the North Dakota-Minnesota border and creating the Twin Towns dynamic with Breckenridge. This river is one of the few in America that flows north, part of the Red River system that drains into Hudson Bay. It connects Wahpeton to the wider Red River Valley — a region stretching from South Dakota to Manitoba.",
    },
  },
  destinations: {
    title: "Where Wahpeton Travelers Go — And Why Passports Get Urgent",
    intro: "Wahpeton's NDSCS student population, Twin Towns location, and agricultural economy shape its international travel patterns.",
    stats: [
      { stat: "30%", label: "of Wahpeton expedited requests involve NDSCS students and faculty" },
      { stat: "3-6 Weeks", label: "average lead time for Twin Towns family international vacations" },
      { stat: "May-Aug", label: "peak season for study abroad prep and family travel" },
      { stat: "260 Miles", label: "distance to nearest passport agency — our courier keeps you in ND" },
    ],
    destinations: [
      { name: "Canada", context: "Manitoba and Ontario fishing trips, Winnipeg shopping excursions, cross-border family visits, Quetico and Atikaki wilderness adventures", urgency: "Year-round border crossing — weekend trips with little planning", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "NDSCS study abroad semesters, agricultural equipment expos in Germany and Italy, Twin Towns family heritage trips to Scandinavia, river cruises", urgency: "Academic deadlines and trade show schedules drive timing", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "NDSCS international students traveling home, ag commodity trade missions to China, agricultural technology conferences in Japan and South Korea", urgency: "Semester breaks and trade mission schedules", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter escapes from North Dakota cold, NDSCS spring break trips, destination weddings, all-inclusive resort vacations", urgency: "Fall and winter bookings as families plan warm getaways", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "NDSCS study abroad programs, agricultural exchange programs, once-in-a-lifetime family adventures, working holiday visas for students", urgency: "Academic semester timelines", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Ag trade missions to Brazil and Argentina, NDSCS international student connections, eco-tourism and adventure travel", urgency: "Mixed timelines depending on trip purpose", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Peace Garden State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Fargo", route: "/cities/fargo" },
      { name: "West Fargo", route: "/cities/west-fargo" },
      { name: "Grand Forks", route: "/cities/grand-forks" },
    ],
  },
  photoLocations: [
    { name: "Wahpeton Post Office", address: "415 2nd Ave N, Wahpeton, ND 58075", hours: "Mon-Fri 9 AM - 3:30 PM (photo service available)" },
    { name: "Breckenridge Post Office", address: "300 5th St N, Breckenridge, MN 56520", hours: "Mon-Fri 8:30 AM - 4 PM (full photo service)" },
    { name: "Walmart Supercenter — Fargo", address: "4201 13th Ave SW, Fargo, ND 58103", hours: "Daily 6 AM - 11 PM (55 min drive)" },
    { name: "Walgreens — Fargo", address: "3175 25th St S, Fargo, ND 58103", hours: "Daily 8 AM - 10 PM (55 min drive)" },
    { name: "The UPS Store — Breckenridge", address: "116 5th St N, Breckenridge, MN 56520", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "ND DOT — Fargo Driver License Office",
      address: "855 45th St S, Fargo, ND 58103",
      hours: "Mon-Fri, 8:00 AM - 4:45 PM (appointment recommended)",
      note: "Driver licenses, REAL ID, vehicle registration. Nearest full-service ND DOT office to Wahpeton. About 55 minutes north on I-29 and I-94.",
      featured: true,
    },
    {
      name: "Richland County Treasurer — Motor Vehicle",
      address: "418 2nd Ave N, Wahpeton, ND 58075",
      hours: "Mon-Fri, 8:00 AM - 4:30 PM",
      note: "Vehicle registration and title services for Richland County. For driver licenses, visit the Fargo ND DOT office.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FAR",
      name: "Hector International Airport (Fargo)",
      distance: "About 55 minutes north of Wahpeton",
      address: "2801 32nd Ave N, Fargo, ND 58102",
      note: "Closest commercial airport serving Wahpeton. Daily flights to Minneapolis, Denver, Chicago, Dallas, and Phoenix. Primary international gateway for southern Red River Valley residents. About 55 minutes from Wahpeton via ND-13 and I-29.",
      flightUrl: "https://www.fargoairport.com/",
      flightLabel: "Fargo Airport Website",
      featured: true,
    },
    {
      code: "ATY",
      name: "Watertown Regional Airport",
      distance: "About 100 miles south of Wahpeton",
      address: "4500 West Hwy 212, Watertown, SD 57201",
      note: "Alternative regional airport with Denver connections. Useful for Wahpeton residents when FAR flights are limited or for travelers heading west.",
      flightUrl: "https://www.watertownsd.us/",
      flightLabel: "Watertown Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified North Dakota birth certificates from the ND Department of Health Vital Records. Online, mail, or in-person options available in Bismarck.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through ND Department of Health Vital Records. Required for estate and legal matters in Richland County.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Richland County Clerk of Court. Certified copies available for name changes and passport applications.",
      url: "https://www.richlandcountynd.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Richland County District Court. Required for name change passport corrections.",
      url: "https://www.richlandcountynd.gov/",
    },
  ],
};